import { DateFieldConfiguration } from '../../../api/ConfigApi';

const claimDateFields = [
	{
		name: 'incidentDate',
		title: 'Incident Date',
		type: 'date',
		optional: false,
		width: 6,
		newline: false,
		order: 0,
		maximumOffset: {
			amount: '0',
			field: 'day',
			roundToDay: true,
		},
		precision: 'day',
		showCalendar: true,
		disabled: false,
	} as DateFieldConfiguration,
	{
		name: 'notificationDate',
		title: 'Notification Date',
		type: 'date',
		optional: true,
		width: 6,
		newline: false,
		order: 1,
		maximumOffset: {
			amount: '0',
			field: 'day',
			roundToDay: true,
		},
		precision: 'day',
		showCalendar: true,
		disabled: false,
	} as DateFieldConfiguration,
];

export default claimDateFields;
